import { CirclesThreeIcon as PhosphorCirclesThreeIcon } from "@phosphor-icons/react/dist/ssr/CirclesThree";

import { createAppIcon } from "@/components/createAppIcon";

export const ReleaseFormatIcon = /* @__PURE__ */ createAppIcon(PhosphorCirclesThreeIcon);
